import { Button, soundManager, SoundType, t } from '@slot-nx/core'
import { Assets, TextStyle } from 'pixi.js'
import { Text } from '@pixi/react'
import tabSelected from '../../../asset/images/betDetail/btn_spin_open.png'
import tabUnselected from '../../../asset/images/betDetail/btn_spin_close.png'
import tabSelectedCorner from '../../../asset/images/betDetail/btn_round_open.png'
import tabUnselectedCorner from '../../../asset/images/betDetail/btn_round_close.png'
import { useBetDetailStore } from '../../domain/betDetail/store/betDetailStore'
import { BetDetailTab, BetDetailType, DetailGameType } from '../../domain/betDetail/enum/betDetailEnum'

Assets.addBundle('SwitchGameTypeTab', [
  {
    alias: 'tabSelected',
    src: tabSelected,
    loadParser: 'loadTextures',
  },
  {
    alias: 'tabUnselected',
    src: tabUnselected,
    loadParser: 'loadTextures',
  },
  {
    alias: 'tabSelectedCorner',
    src: tabSelectedCorner,
    loadParser: 'loadTextures',
  },
  {
    alias: 'tabUnselectedCorner',
    src: tabUnselectedCorner,
    loadParser: 'loadTextures',
  },
])

const selected = new TextStyle({ fontSize: 46, fontWeight: 'bold', fill: '#FFFFFF' })
const unselected = new TextStyle({ fontSize: 46, fontWeight: 'bold', fill: '#606061' })

export const SwitchGameTypeTab = () => {
  const [
    detailGameType,
    detailData,
    getCurrentTableSnapshot,
    selectShowGameType,
  ] = useBetDetailStore(x => [
    x.detailGameType,
    x.betDetailData,
    x.getCurrentTableSnapshot,
    x.selectShowGameType,
  ])
  const snapShots = selectShowGameType === BetDetailTab.Normal ? detailData.gameDetail.snapShots : detailData.gameDetail.godziBetDetail.snapShots
  const { spin, round } = getCurrentTableSnapshot()
  const hasFreeGame = snapShots.some(snapShots => snapShots.type === BetDetailType.NormalFreeGame || snapShots.type === BetDetailType.GodziFreeGame)
  return (
    <>
      <Button
        name="Main Spin Tab"
        x={40}
        y={280}
        width={454}
        height={73}
        onPressing={() => {
          soundManager.play(SoundType.buttonConfirm)
        }}
        onPress={() => {
          useBetDetailStore.setState({
            detailGameType: DetailGameType.Main,
            currentIndex: 0,
          })
        }}
        defaultView="tabUnselected"
        disabledView="tabSelected"
        enabled={detailGameType === DetailGameType.Free}
      />
      <Text text={t('switch_game_type_main_game')} x={(454 / 2) + 40} y={280 + (73 / 2)} anchor={[0.5, 0.5]} style={detailGameType === DetailGameType.Main ? selected : unselected} />

      <Button
        name="Free Spin Tab"
        x={(454 + 494) / 2 + 70}
        y={280}
        width={454}
        height={73}
        onPressing={() => {
          soundManager.play(SoundType.buttonConfirm)
        }}
        onPress={() => {
          if (hasFreeGame) {
            useBetDetailStore.setState({
              detailGameType: DetailGameType.Free,
              currentIndex: useBetDetailStore.getState().getfreeSpinFirstPage(),
            })
          }
        }}
        defaultView="tabUnselected"
        disabledView={hasFreeGame ? 'tabUnselected' : 'tabSelected'}
        enabled={detailGameType === DetailGameType.Main && hasFreeGame}
      />
      <Text
        text={t('switch_game_type_free_game')}
        x={740}
        y={280 + (73 / 2)}
        anchor={[0.5, 0.5]}
        style={hasFreeGame ? selected : unselected}
      />
      <Button
        name="Free Spin Corner"
        x={454 * 2 - 30}
        y={280}
        width={120}
        height={73}
        onPress={() => {
          // console.log('Free Spin Corner')
        }}
        defaultView="tabUnselectedCorner"
        disabledView={hasFreeGame ? 'tabUnselectedCorner' : 'tabSelectedCorner'}
        enabled={detailGameType === DetailGameType.Main
        && hasFreeGame}
      />
      {detailGameType === DetailGameType.Main
        ? null
        : (
            <Text
              text={`${spin}-${round}`}
              x={935}
              y={316}
              anchor={[0.5, 0.5]}
              style={new TextStyle({
                fontSize: 46,
                fontWeight: 'bold',
                fill: '#ffffff',
              })}
            />
          )}
    </>
  )
}
